import React from 'react'
import { Card, Flex, Text, Button, Tooltip, Toolbar, Loader } from '@fluentui/react-northstar'
import { BroadcastIcon, BellIcon, ExcelColorIcon } from '@fluentui/react-icons-northstar'
import { Outlet, useNavigate, useSearchParams,useParams, useOutletContext } from "react-router-dom";
import { setRouteInLocalStorage } from '../../../../shared/contexts/Context';
import { DbMonitoringAlarmHistorical } from './historical';
import { DbMonitoringAlarm } from './recent';
import { INCIDENTLEVELS } from '../../../../shared/appcomponents/enums';
import MonitoringService from '../../../../services/monitoringservice';
import { OPERATIONSTATUS } from '../../../../shared/appcomponents/enums';

const DbMonitoringIncident = (props) => { 
    const { id } = useParams();
    const [viewArea, setViewArea] = React.useState("");
    const [incidents, setIncidents] = React.useState(null);
    const [isLoaded, setLoaded] = React.useState(false);
    const [downloading, setDownloading] = React.useState(false);
    const [searchParams] = useSearchParams();
    let navigate = useNavigate(); 
    const routeChange = (path, varea, refresh) =>{
        setViewArea(varea);
        setRouteInLocalStorage('contentUrl_dashboards', path);
        if(refresh == 1){
            props.updateUser();
        }
        else{
            navigate(path);
        }
    }

    const instanceId =  id ? id :  -1 ;
   const [dbInsCriCount, setdbInsCriCount] = React.useState("");
   const [dbInsWarCount, setdbInsWarCount] = React.useState("");
    React.useEffect(() => {  
        setLoaded(false);
        let _alarmType = searchParams.get('type');
        if(_alarmType){
            setViewArea(_alarmType);
        }
        else{
            _alarmType = 'critical';
            setViewArea("critical");
        }
        props.acquireToken((token) => {
            if(token){                
                let _params = {
                    instanceId: id ? id : -1,
                    incidentLevelId : _alarmType != 'history' ? INCIDENTLEVELS[_alarmType] : -1,
                    appliedFilters:  id
                    ? [`InstanceId IN (${id})`]
                    : [],
                };
                MonitoringService.GetDbMonitoringIncidents(token, _params).then((response) => {
                    if(response && response.status==200){
                      response=response.data;
                      setIncidents(response);
                    }
                    else if(response && response.status==401){
                        props.viewStatus.InformChildPageStatus(response.status);
                      }
                      else {
                        props.viewStatus.InformChildPageStatus(500);
                      }
            
                    setLoaded(true);
                });
                // MonitoringService.GetDbMonAndProvIncCount(token,_params).then((response) => {
                //     if(response && response.status==200){
                //       response=response.data;
                //       //alert(response.DbMonCritical);
                //       //setIncidents(response);
                //       setdbInsCriCount(response.DbMonCritical);
                //       setdbInsWarCount(response.DbMonWarning);               
                      
                //     }
                //     else if(response && response.status==401){
                //         props.viewStatus.InformChildPageStatus(response.status);
                //       }
                //       else {
                //         props.viewStatus.InformChildPageStatus(500);
                //       }
            
                //     //setLoaded(true);
                // });
            }
        });
    }, [searchParams]);

    const handleDownloadCsv = () => {
      let _params = {
            IncidentSection: "1",
            IncidentId: "5091627",
          };
            //console.log('Downloading with filters:', appliedFilters); // Debugging output
            setDownloading(true);
            props.acquireToken((token) => { 
                MonitoringService.DownloadDbMonitoringHistoricalIncidentCsv(token, _params)
                    .then((response) => {
                        if (response.status === 200) {
                            const blob = new Blob([response.data], { type: 'text/csv' });
                            const url = URL.createObjectURL(blob);
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', 'DbMonitoring_Historical_Alerts.csv');
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        } else {
                            console.error('Error downloading CSV:', response.statusText);
                        }
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    })
                    .finally(() => {
                        setDownloading(false);
                    });
            });
        };

    return(
        <>
        <Card fluid className='card card-infra bg-white' elevated >
            <Card.Header>
            <Toolbar
                items={[
                    {
                        key: 'custom-text',
                        content: <Text className='f-size-20' content={`Db Monitoring Alarms ${viewArea != '' ? ': ' + viewArea.toUpperCase() : ''}`} />,
                        kind: 'custom',
                        className: 'heading',
                        fitted: 'horizontally',
                    },
                    {
                        key: 'custom-focusable-text',
                        content: <Button icon={props.monitoringHome ? props.monitoringHome.DbMonitoring?.Critical : '-'} className={`${viewArea == "critical" ? 'selected' : ''}`} content="Critical" iconPosition="after"  onClick={() => routeChange(`/dashboards/monitoring/dbmonitoring/alarms/${instanceId != -1 ? instanceId: ''}?type=critical`, 'critical')} />,
                        focusable: true,
                        kind: 'custom',
                        active: true,
                        className: 'btn critical',
                        fitted: 'horizontally',
                    },
                    {
                        key: 'custom-button',
                        kind: 'custom',
                        content: <Button icon={props.monitoringHome ? props.monitoringHome.DbMonitoring?.Warning : '-'} className={`${viewArea == "warning" ? 'selected' : ''}`} content="Warning" iconPosition="after"  onClick={() => routeChange(`/dashboards/monitoring/dbmonitoring/alarms/${instanceId != -1 ? instanceId: ''}?type=warning`, 'warning')} />,
                        fitted: 'horizontally',
                        className: 'btn warning',
                    },
                    {
                        key: 'custom-infra-history',
                        kind: 'custom',
                        content: <Tooltip pointing iconOnly trigger={<Button className={`${viewArea == "history" ? 'selected' : ''}`} icon={<BellIcon />} text onClick={() => routeChange(`/dashboards/monitoring/dbmonitoring/alarms/${instanceId != -1 ? instanceId: ''}?type=history`, 'history')} />} content="Historical Alarms" />,
                        fitted: 'horizontally',
                        className: 'card-actions',
                    },
                    {
                                                  key: 'custom-service-history-download',
                                                  kind: 'custom',
                                                  content: (
                                                    <Tooltip 
                                                      pointing 
                                                      trigger={
                                                        <Button 
                                                          className={`${viewArea === "history" ? 'selected' : ''}`} 
                                                          icon={downloading ? <Loader size="small" /> : <ExcelColorIcon />} 
                                                          text 
                                                          iconOnly 
                                                          onClick={() => handleDownloadCsv()} 
                                                          disabled={downloading}      
                                                          style={{ paddingRight: "10px" }}               
                                                        />
                                                      }               
                                                      content={downloading ? "Downloading..." : "Download Historical Alarms"}    
                                                                  
                                                    />
                                                    
                                                  ),
                                                  fitted: 'horizontally',
                                                  className: 'card-actions',
                                                 
                                                  
                                                },
                    ]}
                >
                </Toolbar>
            </Card.Header>
            <Card.Body>                            
                {
                    viewArea != "" && isLoaded ?
                    (
                        viewArea != 'history' ?
                        <DbMonitoringAlarm {...props} 
                        incidents={incidents} alarmType={viewArea} routeChange={routeChange} />
                        :
                        <DbMonitoringAlarmHistorical {...props}
                        incidents={incidents} alarmType={viewArea} routeChange={routeChange}/>
                    )
                    :
                    <Loader />
                }
            </Card.Body>
        </Card>
        </>
    )
}

export default DbMonitoringIncident;